// The eBay refund route on a refund step's card (2026-10-29,
// docs/decisions/2026-10-29-ebay-refund-route-every-step.md): which way the
// refund goes, shown before Process in every panel (the step card, the
// Other Actions refund modal, the shadow agent's panel):
//   "Refund on eBay return <id> (open on this order)"
//   "Refund on eBay INR inquiry <id> (open on this order)"
//   "eBay case <id> is open: refund it on the case in Seller Hub"
//   "Seller refund on the eBay order (no open return, inquiry or case)"
// The id links the way the contact card links it (ebayLinks.js).
import { Fragment } from 'react'
import { Link, Typography } from '@mui/material'
import { ebayRefundRouteUrl } from './ebayLinks.js'

export function EbayRefundRouteNote({ route, testId = 'ebay-refund-route', sx = null }) {
  if (!route?.text) return null
  const id = route.id == null ? '' : String(route.id)
  const url = id ? ebayRefundRouteUrl(route) : null
  const text = String(route.text)
  const parts = url && text.includes(id) ? text.split(id) : null
  return (
    <Typography variant="caption" display="block" sx={{ mt: 0.5, fontWeight: 600, ...(sx ?? {}) }} data-testid={testId} data-route={route.via ?? undefined}>
      {parts
        ? parts.map((part, i) => (
          <Fragment key={i}>
            {part}
            {i < parts.length - 1 && <Link href={url} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-link`}>{id}</Link>}
          </Fragment>
        ))
        : text}
    </Typography>
  )
}

export default EbayRefundRouteNote
